import React, { useState, useEffect, useCallback } from 'react';
import api from '../api/axios';

const POLL_INTERVAL = 30000; // NotificationBell bilan bir xil naqsh

// Nav bandi yonidagi umumiy o'qilmagan so'rovlar soni - INQUIRY_STAFF_ROLES
// bo'lmagan foydalanuvchi uchun App.tsx bu komponentni umuman render qilmaydi
// (403 kutilmagan holat emas, faqat chaqirilmaydi).
const InquiriesBadge: React.FC = () => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const res = await api.get('/inquiries/unread-count');
      setCount(res.data.count || 0);
    } catch (e) { /* sukutda */ }
  }, []);

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [fetchCount]);

  if (count === 0) return null;
  return (
    <span className="bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1">
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default InquiriesBadge;
